(function () {
    'use strict';
    angular.module('app').controller('RoutePlanningController', RoutePlanningController);
    RoutePlanningController.$inject = [
        'RPJobAssignmentTable',
        'RPRunsTable',
        'ClientService',
        'toastr'
    ];

    function RoutePlanningController(
        RPJobAssignmentTable,
        RPRunsTable,
        ClientService,
        toastr
    ) {
        const vm = this;

        init();

        function init() {
            ClientService.Client.getAvailableCompany(data => {
                initTables(data);
            }, error => {
                toastr.error(error.message, 'Error');
            });
        }

        function initTables(offices) {
            vm.jobAssignmentTable = new RPJobAssignmentTable(offices).tableData;
            vm.saveRunsTable = new RPRunsTable().tableData;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/route-planning/RoutePlanningController.js